import { STORAGE_URL } from "variables";

const getImageSrc = (image) => {
  if (!image || image === "null") return "";
  if (image instanceof File) return URL.createObjectURL(image);
  return `${STORAGE_URL}${image}`;
};

const hasImageValue = (image) => {
  if (!image || image === "null") return false;
  if (typeof image === "string") return image.trim() !== "";
  if (image instanceof File) return true;
  if (typeof image.length === "number") return image.length > 0;
  return true;
};

export const hasSectionImage = (image, mobileImage) =>
  hasImageValue(image) || hasImageValue(mobileImage);

const SectionImage = ({ image, mobileImage, alt, children, onClick }) => {
  const src = getImageSrc(image);
  const mobileSrc = getImageSrc(mobileImage);
  const fallbackSrc = src || mobileSrc;
  if (!fallbackSrc) return null;
  const isClickable = typeof onClick === "function";

  const handleKeyDown = (event) => {
    if (!isClickable) return;
    if (event.key !== "Enter" && event.key !== " ") return;

    event.preventDefault();
    onClick(event);
  };

  return (
    <section
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role={isClickable ? "button" : undefined}
      tabIndex={isClickable ? 0 : undefined}
      style={{
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",
        overflow: "visible",
        position: "relative",
        cursor: isClickable ? "pointer" : "default",
      }}
    >
      <picture style={{ display: "block", width: "100%" }}>
        <source media="(max-width: 767px)" srcSet={mobileSrc || fallbackSrc} />
        <img
          src={fallbackSrc}
          alt={alt || "Imagem da seção"}
          style={{
            width: "100%",
            height: "auto",
            display: "block",
            objectFit: "contain",
            objectPosition: "center",
          }}
        />
      </picture>
      {children && (
        <div
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            width: "min(28rem, calc(100% - 2rem))",
            zIndex: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {children}
        </div>
      )}
    </section>
  );
};

export default SectionImage;
